import React from 'react'
import { setPageTitle } from 'hooks/setPageTitle'
import { TitleUtil } from 'utility/TitleUtil'
import { Body } from './Body'
import { TemplateSideColumn } from 'shared/template/SideColumn'

export const App = (props) => {
  const email = decodeURI(
    new URLSearchParams(props.location.search).get('email')
  )

  setPageTitle(TitleUtil.resetPassword())
  const content = <>
    <Body email={email} />
  </>

  return <TemplateSideColumn content={content}/>
}

